import { computed, getCurrentInstance } from "vue";

/** Shown only when `featureFlags/ideaMDP442` is on. */
const COLUMNS_IDEA_MDP_442 = new Set(["attachedRoles", "coaches", "masters"]);

export function useTableConfig(viewState) {
  const store = getCurrentInstance()?.proxy?.$store;

  const tableParams = computed(() => {
    const ideaMDP442 = store?.getters?.["featureFlags/ideaMDP442"] === true;

    const headers = [
      {
        text: "Responsibilities",
        value: "name",
        width: "280px",
      },
      {
        text: "Attached to Roles",
        value: "attachedRoles",
        width: "180px",
      },
      {
        text: "Average Readiness",
        value: "readiness",
        width: "220px",
      },
      {
        text: "Badge Holders",
        value: "badges",
        width: "200px",
      },
      {
        text: "Coaches",
        value: "coaches",
        width: "160px",
      },
      {
        text: "Masters",
        value: "masters",
        width: "160px",
      },
    ];

    const columns = [
      {
        field: "",
        component: "OrgObjectCard",
        props: (item) => ({
          class: "my-4 org-object-card--resp-directory",
          ...viewState.getOrgObjectCardProps(item),
        }),
        events: (item) => ({
          openPopup: () => {
            viewState.navigateToResponsibility(item, "checklist");
          },
        }),
      },
      {
        field: "",
        component: "AttachedToARoleAndMoreBadge",
        props: (item) => ({
          ...viewState.getAttachedToRolesProps(item),
        }),
        events: (item) => ({
          click: () => {
            viewState.navigateToResponsibility(item, "assignments");
          },
        }),
      },
      {
        field: "",
        component: "ResponsibilityDirectoryReadinessBar",
        props: (item) => ({
          class: "my-4",
          readinessProps: viewState.getReadinessBarProps(item),
          resId: item.id,
          directoryItem: item,
        }),
      },
      {
        field: "",
        component: "EmployeeBadgeCounter",
        props: (item) => ({
          class: "my-4",
          ...viewState.getEmployeeBadgeCounterProps(item),
        }),
        events: (item) => ({
          click: () => {
            viewState.navigateToResponsibility(item, "badge-holders");
          },
        }),
      },
      {
        field: "",
        component: "PeopleAvatarsButton",
        props: (item) => ({
          ...viewState.getCoachesAvatarsProps(item),
        }),
        events: (item) => ({
          onAvatarClick: () => {
            viewState.navigateToResponsibility(item, "coaches");
          },
        }),
      },
      {
        field: "",
        component: "PeopleAvatarsButton",
        props: (item) => ({
          ...viewState.getMastersAvatarsProps(item),
        }),
        events: (item) => ({
          onAvatarClick: () => {
            viewState.navigateToResponsibility(item, "masters");
          },
        }),
      },
    ];

    const visible = headers
      .map((h, i) => [h, columns[i]])
      .filter(([h]) => ideaMDP442 || !COLUMNS_IDEA_MDP_442.has(h.value));

    return {
      headers: visible.map(([h]) => h),
      columns: visible.map(([, c]) => c),
      filters: {
        values: viewState.state.filters.values,
        searchText: viewState.state.filters.searchText,
        searchGhostText: "Search Responsibility or Role",
      },
      hideTopSection: true,
      showActionButton: true,
      hideActiveNo: true,
      hideFilterBtn: false,
      defaultOrderingField: "name",
      hideGridView: true,
      hideButtonIcon: true,
      title: "Responsibilities",
      hideButtonInMessage: true,
    };
  });

  return {
    tableParams,
  };
}
